import Image from 'next/image';

const blurple = '#5865f2';
export const DiscordLogo = ({ size = 32 }: { size?: number }) => {
  return (
    <div
      style={{
        backgroundColor: blurple,
      }}
      className={`p-1 w-[${size}px] h-[${size}px] rounded-lg flex items-center justify-center transition-all duration-150 cursor-pointer`}
    >
      <Image src="/Discord-Symbol-White.png" width={size} height={size} alt="Discord" />
    </div>
  );
};
